import type { MenuIconComponent } from './menuIcons';
import {
  FacebookIcon,
  FileDocumentIcon,
  FileEditIcon,
  HeadsetIcon,
  HomeIcon,
  InstagramIcon,
  LinkedinIcon,
  QrcodeIcon,
  TruckIcon,
  WrenchIcon,
  YoutubeIcon,
} from './menuIcons';

type Page = {
  name: string;
  slug: string[];
  icon?: MenuIconComponent;
  url?: string;
  ariaLabel?: string;
  showLink?: boolean;
  param?: string;
  type?: string;
  action?: 'chat';
  subMenu?: Page[];
};

export const pages: Page[] = [
  {
    name: 'Início',
    slug: ['inicio'],
    icon: HomeIcon,
    url: 'portal',
    ariaLabel: 'Página inicial',
    showLink: true,
  },
  {
    name: 'Meus boletos',
    slug: ['boletos'],
    icon: QrcodeIcon,
    url: 'boletos',
    ariaLabel: 'Página de meus boletos',
    showLink: true,
  },
  {
    name: 'Minhas notas',
    slug: ['notas'],
    icon: QrcodeIcon,
    url: 'notas',
    ariaLabel: 'Página de minhas notas',
    showLink: true,
  },
  {
    name: 'Abastecimento',
    slug: ['abastecimento', 'pedido-abastecimento', 'tracking', 'pendencias'],
    icon: TruckIcon,
    url: 'abastecimento',
    ariaLabel: 'Página abastecimento',
    showLink: true,
    subMenu: [
      {
        name: 'Novo pedido',
        slug: ['pedido-abastecimento'],
        url: 'pedido-abastecimento',
        ariaLabel: 'Página novo pedido',
        showLink: true,
      },
      {
        name: 'Histórico de solicitações',
        slug: ['tracking'],
        url: 'tracking',
        ariaLabel: 'Página histórico de solicitações',
        showLink: true,
      },
      {
        name: 'Melhores horários',
        slug: ['melhores-horarios'],
        url: 'melhores-horarios',
        ariaLabel: 'Página melhores horários',
        showLink: true,
      },
    ],
  },
  {
    name: 'Manutenção',
    slug: ['main-manutencao', 'manutencao', 'documentacao-os'],
    icon: WrenchIcon,
    url: 'main-manutencao',
    ariaLabel: 'Página manutenção',
    showLink: true,
    subMenu: [
      {
        name: 'Solicitar manutenção',
        slug: ['manutencao'],
        url: 'manutencao',
        ariaLabel: 'Página Manutenção',
        showLink: true,
      },
      {
        name: 'Histórico de ordens de serviço',
        slug: ['documentacao-os'],
        url: 'documentacao-os',
        ariaLabel: 'Histórico de ordens de serviço',
        showLink: true,
      },
    ],
  },
  {
    name: 'Documentos técnicos',
    slug: ['documentacao'],
    icon: FileDocumentIcon,
    url: 'documentacao',
    ariaLabel: 'Pasta técnica',
    showLink: true,
  },
  {
    name: 'Meus contratos',
    slug: ['meus-contratos'],
    icon: FileDocumentIcon,
    url: 'meus-contratos',
    ariaLabel: 'Meus contratos',
    showLink: true,
  },
  {
    name: 'Adicionar empresa',
    slug: ['nova-empresa'],
    icon: FileEditIcon,
    url: 'nova-empresa',
    ariaLabel: 'Página novo contrato',
    showLink: true,
  },
  {
    name: 'Fale conosco',
    slug: [
      'contato',
      'duvidas-frequentes',
      'dicas-seguranca',
      'atendimento-comercial',
    ],
    icon: HeadsetIcon,
    url: 'contato',
    ariaLabel: 'Página fale conosco',
    showLink: true,
    subMenu: [
      {
        name: 'Dúvidas frequentes',
        slug: ['duvidas-frequentes'],
        url: 'fale-conosco',
        ariaLabel: 'Página dúvidas frequentes',
        showLink: true,
        param: 'faq',
      },
      {
        name: 'Falar via chat',
        slug: ['chat'],
        ariaLabel: 'Falar via chat',
        showLink: true,
        action: 'chat',
      },
      {
        name: 'Dicas de segurança',
        slug: ['dicas-seguranca'],
        url: 'dicas-seguranca',
        ariaLabel: 'Página dicas de segurança',
        showLink: true,
      },
      {
        name: 'Atendimento comercial',
        slug: ['atendimento-comercial'],
        url: 'atendimento-comercial',
        ariaLabel: 'Página atendimento comercial',
        showLink: true,
      },
    ],
  },
];

export const socials = [
  {
    icon: FacebookIcon,
    alt: 'Facebook',
    href: 'https://www.facebook.com/ultragazoficial/',
  },
  {
    icon: YoutubeIcon,
    alt: 'Youtube',
    href: 'https://www.youtube.com/user/UltragazBrasilgas',
  },
  {
    icon: InstagramIcon,
    alt: 'Instagram',
    href: 'https://www.instagram.com/ultragazoficial/',
  },
  {
    icon: LinkedinIcon,
    alt: 'Linkedin',
    href: 'https://www.linkedin.com/company/ultragaz/mycompany/',
  },
];
